import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      outline: 'none',

      '& h1': {
        ...theme.typography.h1,
        fontWeight: theme.typography.fontWeightSemiBold,
      },
      '& h2': {
        ...theme.typography.h2,
      },
      '& h3': {
        ...theme.typography.h3,
      },
      '& ul': {
        listStyleType: 'disc',
        listStylePosition: 'outside',
        marginLeft: '1.5em',
      },
      '& ol': {
        listStyleType: 'decimal',
        listStylePosition: 'outside',
        marginLeft: '1.5em',
      },
    },
  }),
  { name: 'CustomEditable' }
);
